import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import './pricing.css';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

import green from '@material-ui/core/colors/green';
import MenuItem from '@material-ui/core/MenuItem';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

import Checkout from './Checkout.js';

import Review from './Review.js'
import {
  BrowserRouter as Router,
  Route,
  Link,
  NavLink,
  Redirect,
  withRouter,

} from 'react-router-dom'

// import AddressForm from './AddressForm.js'
import Typography from '@material-ui/core/Typography';
import ArrowBackIos from '@material-ui/icons/ArrowBackIos'
import { checkServerIdentity } from 'tls';

const currencies = [
  {
    value: 'USD',
    label: '$',
  },
  {
    value: 'EUR',
    label: '€',
  },
  {
    value: 'BTC',
    label: '฿',
  },
  {
    value: 'JPY',
    label: '¥',
  },
];


const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    // marginLeft: theme.spacing.unit,
    // marginRight: theme.spacing.unit,
    marginBottom: "10px",
    width: '100%',
    textAlign: "center",
    color: "#203b60",

    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  },
  paperRoot: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    // width:'100%'
  },
  paperImp: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginTop: '15px'
    // width:'100%'
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
    flexDirection: 'row'
  },
  root: {
    width: '90%',
  },
  button: {
    // margin: theme.spacing.unit,
    // boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    // fontWeight:'800',
    width:'100%',
    padding: '3px 6px',
    border: '1px solid',
    color: 'white',
    // lineHeight: 1.5,
    backgroundColor: 'rgb(37,106,167)',
    borderColor: 'rgb(37,106,167)',
    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
    '&:hover': {
      backgroundColor: '#203b60',
      borderColor: '#203b60',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#0062cc',
      borderColor: '#005cbf',
    },
  },
  buttonBack: {

    textTransform: 'none',
    fontSize: 16,
    padding: '3px 6px',
    color: '#203b60',
    width:'100%',
    backgroundColor: '#f2f2f2',
    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),

  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
});

function getSteps() {
  return ['Revisión de Orden', 'Ingreso de Datos', 'Confirmación de Orden'];
}

function getStepContent(step) {
  switch (step) {
    case 0:
      return 'Revisión de Orden';
    case 1:
      return 'Ingreso de Datos';
    case 2:
      return 'Confirmación de Orden';
    default:
      return 'Unknown step';
  }
}

class MainConfirmation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      skipped: new Set(),
    }
    this.getTotalMonth = this.getTotalMonth.bind(this);
    this.getTotalApps = this.getTotalApps.bind(this);
    this.goFinalStep = this.goFinalStep.bind(this);
    this.backToSelection = this.backToSelection.bind(this);


  }

  componentDidMount() {
    window.scrollTo(0, 0)
    console.log("TEST PARAMS ON FLY")
    console.log(this.props.history.location)
    console.log("USERS")
    console.log(this.props.history.location.state.data.users)
    console.log(this.props.history.location.state.data.all_prices.user[this.props.history.location.state.data.period])
    if(this.props.history.location.state.activeStep !== undefined){

      this.setState({
        activeStep:this.props.history.location.state.activeStep,
        form:this.props.history.location.state.form
      })
    }



  }

  getPath(step){
    switch(step){
      case 0:return '/review';
      case 1: return '/form';
      case 2: return '/confirm'
    }
  }

  handleNext = (data) => {
    const { activeStep } = this.state;
    let { skipped } = this.state;
    if (this.isStepSkipped(activeStep)) {
      skipped = new Set(skipped.values());
      skipped.delete(activeStep);
    }
    var nextStep = activeStep + 1
    var path = this.getPath(nextStep)
    var Hdata = this.props.history.location.state.data
    if(data.form){
      Hdata['form'] = data.form
      if(data.form.payment_method === 'credit'){
        Hdata['token']= data.token
      }
      // 
    }

    console.log("DATA ARMADA PARA PUSH")
    console.log(Hdata)
   

    this.setState({
      activeStep: activeStep + 1,
      skipped,
    }, this.props.history.push({
      pathname: path,
      // search: '?query=abc',

      state: { data: Hdata, activeStep:nextStep }
    }));

  };

  backToSelection(){
    console.log("Going Back please")
    console.log(this.props.history)
    // this.props.history.goBack()
    this.props.history.push({
      pathname: 'selection',
      // search: '?query=abc',
      state: { data: this.props.history.location.state.data }
    })
  }

  handleBack = () => {
    var backStep = this.state.activeStep -1
    var path = this.getPath(backStep)
    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }, this.props.history.push({
      pathname:path,
      state: { data: this.props.history.location.state.data, activeStep:backStep }
    })));
    
  };

  async goFinalStep(data) {
    console.log("ON FINAL STEP")
    console.log("TOKEN")
    console.log(data.token)
    console.log("form data")
    console.log(data.form)
    this.setState({
      form: data.form,
      token: data.token
    })
    this.handleNext(data)
  }

  handleSkip = () => {
    const { activeStep } = this.state;
    if (!this.isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    this.setState(state => {
      const skipped = new Set(state.skipped.values());
      skipped.add(activeStep);
      return {
        activeStep: state.activeStep + 1,
        skipped,
      };
    });
  };

  handleReset = () => {
    this.setState({
      activeStep: 0,
    });
  };

  isStepSkipped(step) {
    return this.state.skipped.has(step);
  }

  isStepOptional = step => step === 1;

  getTotalApps() {
    var total = 0;
    var data = this.props.history.location.state.data
    data.selected_apps.map(function (app) {


      total += app[data.period]
    }.bind(this))

    // this.setState({
    //   total:total
    // })
    return total
  }

  getTotalMonth() {
    var data = this.props.history.location.state.data
    var total;

    var users = (parseInt(data.users) * data.all_prices.user[data.period])
    var total_users = users - (users * data.all_prices.user.discount_new_user)

    total = this.getTotalApps() + total_users + data.selected_support_data[data.period]

    if (data.period === 'month') {
      return total = total
    }
    else if (data.period === 'year') {
      return total * 12
    }

    console.log("TOTAL MONTH")
    console.log(total)
    return total
  }

  getTaxes() {
    return 0
  }

  nameChange(event) {
    console.log("name Change")
  }



  round(num, decimales = 2) {
    var signo = (num >= 0 ? 1 : -1);
    num = num * signo;
    if (decimales === 0) //con 0 decimales
        return signo * Math.round(num);
    // round(x * 10 ^ decimales)
    num = num.toString().split('e');
    num = Math.round(+(num[0] + 'e' + (num[1] ? (+num[1] + decimales) : decimales)));
    // x * 10 ^ (-decimales)
    num = num.toString().split('e');
    return signo * (num[0] + 'e' + (num[1] ? (+num[1] - decimales) : -decimales));
}


  render() {
    const { classes } = this.props;
    const steps = getSteps();
    const { activeStep } = this.state;
    const data = this.props.history.location.state.data
    return (

      <div className="col-md-12" style={{ marginTop: "88px", marginBottom:"30px" }}>
        <div className="row">

          <div style={{ marginBottom: '10px' }} className="col-md-12">
            <Stepper style={{ backgroundColor: 'transparent', width: '100%', overflowX: 'hidden', paddingLeft: '0px' }} activeStep={activeStep}>
              {steps.map((label, index) => {
                const props = {};
                const labelProps = {};

                return (
                  <Step key={label} {...props}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </div>

              {/* active step 0 */}
          {this.props.history.location.pathname === '/review' &&


            <div className="col-md-8" >

              <Paper className={classes.paperRoot} elevation={1}>
                <div className="col-md-12 user-selection">
                  <div className="pricing-title">Revise su selección</div>
                </div>

                <div className="table-responsive">
                  <table className='table table-condensed price-grid-table order-detail-table'>
                    <tbody>

                      {/* Users */}
                      <tr>
                        <td className="td-support-content">{data.users} Usuarios</td>
                        <td style={{ textAlign: 'right' }}>${parseInt(data.users) * data.all_prices.user[data.period]} USD</td>
                      </tr>
                      <tr>
                        <td className="td-support-content">Descuento: {data.users} Nuevos Usuarios</td>
                        <td style={{ textAlign: 'right', color: 'red' }}>-${this.round((data.users * data.prices.user[data.period]) * data.prices.user.discount_new_user)} USD</td>
                      </tr>


                      {/* Apps */}
                      {data.selected_apps.map((app, index) => (
                        <tr>
                          <td className="td-support-content" >{app.name}</td>
                          <td style={{ textAlign: 'right' }}>$ {app[data.period]} USD</td>

                        </tr>

                      ))}

                      {/* Service Pack */}

                      <tr>
                        <td className="td-support-content" >{data.selected_pack_data.name}</td>
                        <td style={{ textAlign: 'right' }}>$ {data.selected_pack_data.new} USD</td>

                      </tr>



                      {/* Support */}
                      <tr>
                        <td className="td-support-content">Soporte {data.selected_support_data.name}</td>
                        <td style={{ textAlign: 'right' }}>${data.selected_support_data[data.period]} USD</td>
                      </tr>



                    </tbody>

                  </table>

                  
                        <div style={{display:'flex'}}>
                  <Grid className={classes.commonMargin} direction='row' alignItems='flex-end' justify='space-between' container>
                    <Grid item xs={12} sm={4}>
                      <Button onClick={this.backToSelection} variant="contained" className={classes.buttonBack}>
                        <i style={{ marginRight: "8px" }} className="fa fa-1x fa-chevron-left"></i>
                        Volver
                  </Button>
                    </Grid>

                    <Grid item xs={12} sm={4}>

                      <Button onClick={this.handleNext} variant="contained" className={classes.button}>
                        Siguiente
                    <i style={{ marginLeft: "8px" }} className="fa fa-1x fa-chevron-right"></i>
                      </Button>

                    </Grid>
                  </Grid>
                  </div>
                  

                  {/* <div style={{ marginBottom: "10px", display: "flex" }}>


                  <div className="col-md-6">
                    <Button onClick={this.props.back} variant="contained" className={classes.buttonBack}>
                      <i style={{ marginRight: "8px" }} className="fa fa-1x fa-chevron-left"></i>
                      Volver
              </Button>
                  </div>

                  <div style={{ textAlign: "right" }} className="col-md-6">
                    <Button onClick={this.handleNext} variant="contained" className={classes.button}>
                      Siguiente
                <i style={{ marginLeft: "8px" }} className="fa fa-1x fa-chevron-right"></i>
                    </Button>
                  </div>



                </div> */}

                </div>

              </Paper>
            </div>
          }

          {this.props.history.location.pathname === '/review' &&

            <div className="col-md-4 price-main">
              <div className="sticky-top-custom">
                <Paper className={classes.paperRoot} elevation={1}>
                  <div className="table-responsive">
                    <div className="pricing-title">Resumen</div>
                    <table style={{ fontSize: "14px" }} className='price-grid-table'>
                      <tbody>
                        <tr>
                          <td className="td-support-content">Servicios Regulares <sup>(1)</sup></td>
                          <td style={{ textAlign: 'right' }}>$ {this.getTotalMonth()} USD</td>

                        </tr>
                        <tr>
                          <td className="td-support-content">{data.selected_pack_data.id === 99 ? "" : "Implementación:"} {data.selected_pack_data.name}  {data.selected_pack_data.new !== 0 ? <sup>(2)</sup> : ""}</td>
                          <td style={{ textAlign: 'right' }}>$ {data.selected_pack_data.new} USD</td>

                        </tr>

                        <tr>
                          <td className="td-support-content">Sub-Total</td>
                          <td style={{ textAlign: 'right' }}>$ {this.getTotalMonth() + data.selected_pack_data.new} USD</td>

                        </tr>
                        <tr>
                          <td className="td-support-content"> Impuestos</td>
                          <td style={{ textAlign: 'right' }}>$ {0.00} USD</td>

                        </tr>

                        <tr>
                          <td><strong>Total</strong></td>
                          <td style={{ textAlign: 'right' }}>$ {this.getTotalMonth() + data.selected_pack_data.new + this.getTaxes()} USD</td>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Paper>
                <div className="small-conditions">
                  <small><sup>(1)</sup>Servicios Regulares: {data.period === "year" ? "Esta tarifa se facturará anualmente" : "Esta tarifa se facturará mensualmente"}</small>


                </div>
                <div className="small-conditions">
                  {data.selected_pack_data.new !== 0 &&
                    <small><sup>(2)</sup>Servicios de Implementación: Este servicio se facturará por única vez, a menos que sea contratado nuevamente</small>

                  }
                </div>

              </div>
            </div>
          }
        </div>



        {/* STEP 2 */}

        {this.props.history.location.pathname === '/form' &&
          // <div className="col-md-12">

          // <div className="col-md-8" style={{ paddingBottom: "15px" }}>

          <Checkout step='form' back={this.handleBack} nextStep={this.goFinalStep} />


        }
        {/* {this.state.activeStep === 2 && this.state.token !== undefined && */}
        {this.props.history.location.pathname === '/confirm' &&

          // <div className="col-md-8" >

          //   <Paper className={classes.paperRoot} elevation={1}>
          //     <div className="col-md-12 user-selection">
          //       <div className="pricing-title">{this.state.token.id}</div>
          //     </div>

          //     </Paper>
          //     </div>
          // <Checkout services={this.props} period={this.props.period} stripeToken={this.state.token} data={this.state.form} nextStep={this.goFinalStep} />
          // <Review stripeToken={this.state.token} data={this.state.form}/>


          // amount={this.getTotalMonth() + this.props.pack.new + this.getTaxes()}
          <Review period={this.props.period} back={this.handleBack} stripeToken={this.state.token} form={this.state.form}  services={this.props} data={data} getTotalMonth={this.getTotalMonth} getTaxes={this.getTaxes} />
        }




      </div>

      // }




    );
  }
}


MainConfirmation.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(MainConfirmation));


// export default AppsGrid;